import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { FC, ReactNode } from "react";
import { ISectionTitle } from "../../../models/common/common";
import styles from "../../../styles/home/Home.ItalianTour.module.scss";
import SectionTitle from "../../common/SectionTitle";

const ItalianTourLayout: FC<{
    sectionTitleData: ISectionTitle;
    children: ReactNode;
}> = ({ sectionTitleData, children }) => {
    return (
        <MDBContainer fluid className={`${styles.italianTour} p-0`}>
            <MDBRow className="justify-content-center p-md-5">
                <MDBCol
                    lg={11}
                    className={`${styles.italianTourContent} flex-fill pt-5 my-md-5`}
                >
                    <MDBRow className="d-flex justify-content-center px-3 px-md-5">
                        <MDBCol size={12}>
                            <SectionTitle sectionTitle={sectionTitleData} />
                        </MDBCol>
                    </MDBRow>
                    {children}
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default ItalianTourLayout;
